import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorHandlingService } from './abc-core-error-handling.service';

@NgModule({
  imports: [CommonModule],
  providers: [ErrorHandlingService],
})
export class AbcCoreErrorHandlingModule {}
